<template>
	<div id="Editor">
		<v-content>

			<!--//*Confirmação de mudança de página  -->
			<v-dialog v-model="confirmAction.enabled" max-width="600px">
				<v-card>
					<v-card-title>
						<span class="headline">Você tem certeza que quer mudar de página?</span>
					</v-card-title>
					<v-card-text>
						<v-container grid-list-md>
							<v-layout wrap>
								<v-flex xs12>
									<span>As alterações não salvas serão perdidas.</span>
								</v-flex>
							</v-layout>
						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue darken-1" flat @click="confirmAction.enabled = false">Cancelar</v-btn>
						<v-btn color="blue darken-1" flat @click="selectSite(pageInfo.site, pageInfo.pagina, pageInfo.pageIndex)">Confirmar</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<!-- //*Mostrar nome da página selecionada -->
			<v-toolbar>
				<span v-if="selectedPage" class="headline">{{siteName}} > {{selectedPage.nome}}</span>
				<v-spacer/>
				<v-btn @click="saveContent(selectedSite, pageIndex)" color="extra" dark>Salvar</v-btn>
			</v-toolbar>

			<v-layout row>
				<!-- //*Navegação de sites -->
				<v-flex xs3>
					<v-card>
						<v-card-text>
							<v-list>
								<v-list-group v-model="item.active" v-for="(item, index) in sites" :key="index" prepend-icon="folder" no-action>
									
									<!-- Nome do site -->
									<v-list-tile slot="activator">
										<v-list-tile-content>
											<v-list-tile-title>{{item.nome}}</v-list-tile-title>
										</v-list-tile-content>
									</v-list-tile>
									<!-- Paginas do site -->
									<v-list-tile :id="index" class="r-item-sites" v-for="(subItem, index) in item.paginas" :key="index" @click="changeSite(item, subItem, index)">
										<v-list-tile-content>
											<v-list-tile-title>
												<v-icon small>description</v-icon>{{subItem.nome}}
											</v-list-tile-title>
										</v-list-tile-content>
									</v-list-tile>

									<v-btn block @click="$router.push({ name: 'paginas', query: {siteId: item['.key']}})" >Administrar</v-btn>
								</v-list-group>
							</v-list>
						</v-card-text>
					</v-card>

				</v-flex>
				<!-- //*Editor de texto -->
				<v-flex xs9>
					<template>
						<!-- //*Instância do editor -->
						<div id="textEditorWrapper" class="mb-2">
							<textarea id="textEditor"></textarea>
						</div>
					</template>
				</v-flex>
			</v-layout>

			<!-- //*Snackbar de aviso para salvar -->
			<v-snackbar color="secondary" v-model="alert.enabled" top :timeout=snackTime>
				<span dismissible="true">{{alert.content}}</span>
			</v-snackbar>
		</v-content>
	</div>
</template>

<script>
//*Importação do Banco de Dados do firebase
import { db } from '../firebase'

//*Constante para referenciar o banco de dados
const sitesRef = db.ref('sites')

//*Importação do editor de texto Jodit
import 'jodit/build/jodit.min.css'
import Jodit from 'jodit'

//*Variável para aplicações do Jodit
var editor

export default {
	name: 'Editor',

	firebase() {
		//*Caso já exista uma query de site para o editor
		if(this.$route.query.siteSelecionado){
			return {
				sites: {
					source: sitesRef.orderByChild('status').equalTo('ativo')
				},
				siteSelecionadoUrl: {
					source: sitesRef.child(this.$route.query.siteSelecionado),
					asObject: true
				},
				paginaSelecionadaUrl: {
					source: sitesRef.child(this.$route.query.siteSelecionado + '/paginas/' + this.$route.query.paginaSelecionada),
					asObject: true
				}
			}
		//*Caso não exista uma query de site pro editor
		}else {
			return {
				sites: {
					source: sitesRef.orderByChild('status').equalTo('ativo')
				}
			}
		}
	},
	data() {
		return {
			//*Variáveis de referencia para o query
			item: null,
			siteSelecionadoUrl: null,
			paginaSelecionadaUrl: null,

			//* Seleção de sites e páginas
			siteName: null,
			selectedSite: null,
			selectedPage: {
				content: '',
			},
			pageIndex: null,
			//lista
			sites: {},
			sitesArr: null,
			mirror: false,

			//*Confirmação de mudança de página
			confirmAction: {
				enabled: false
			},
			pageInfo: {
				site: null,
				pagina: null,
				pageIndex: null,
			},
			//* Snackbar
			snackTime: 2000,
			alert: {
				enabled: false,
				content: '',
			}
			
		}
	},
	methods: {
		//* Método temporário para adicionar blocos no conteúdo do editor
		preview() {
			//String de "placeholder"
			//TODO: Adicionar novos "placeholders"
			var string = '<sup>?formulario?</sup>'
			//String para conversão
			//TODO: Adicionar outros blocos
			var result = 'FORMULARIO'
			//Transforma "placeholders" em blocos
			var final = editor.value.split(string).join(result)
			// console.log(final)
			editor.value = final
		},
		//*Salvar o conteúdo editado
		saveContent(site, pagina) {
			this.preview()
			let childRef = sitesRef.child(site + '/paginas/' + pagina)
			childRef.update({
				content: editor.value
			}).then(
				this.showSnack('Salvo!')
			).then(
				this.selectedPage.content = editor.value
			)
		},
		changeSite(site, pagina, pageIndex){
			//*Salva as variáveis para confirmar com o selectSite() depois
			//Se já tiver selecionado uma página
			if(this.selectedPage.content != editor.value){
					this.pageInfo.site = site
					this.pageInfo.pagina = pagina
					this.pageInfo.pageIndex = pageIndex
					this.confirmAction.enabled = true
			}
			else{
				this.selectSite(site, pagina, pageIndex)
			}
			
		},
		//*Seleciona um site e define as variáveis com suas configurações e faz o item do seletor de sites ficar "r-active" (cinza)
		selectSite(site, pagina, pageIndex) {
			this.siteName = site.nome
			this.selectedSite = site['.key']
			this.selectedPage = pagina
			this.pageIndex = pageIndex
			var itensLista = document.getElementsByClassName('r-active')
			var itensListaArr = [].slice.call(itensLista)
			itensListaArr.forEach(element => {
				element.classList.remove('r-active')
			})
			var idPageIndex = document.getElementById(pageIndex)
			if(idPageIndex){
				idPageIndex.classList.add('r-active')
			}
			this.confirmAction.enabled = false
		},
		//*Mostra uma snackbar
		showSnack(mensagem) {
			this.alert.content = mensagem,
			this.alert.enabled = true
		}
	},
	mounted() {
		//* Caso alguma página mande redicionamento por query
		if(this.paginaSelecionadaUrl){
			// console.log('ta pronto no mounted')
			this.siteName = this.siteSelecionadoUrl.nome
			this.selectedSite = this.$route.query.siteSelecionado 
			this.pageIndex = this.$route.query.paginaSelecionada
			this.selectedPage = this.paginaSelecionadaUrl
		}
	
		//* Variáveis do editor (e suas configurações personalizadas)
		var editorConfig = {
			placeholder: 'Começe a digitar',
			config: {
				language: 'pt_br'
			},
			buttons: ['source', 'bold', 'strikethrough', 'underline', 'italic', 'superscript', 'subscript', 'ul', 'ol', 'outdent', 'indent', 'font', 'fontsize', 'brush', 'paragraph', 'image', 'video', 'table', 'link', 'align', 'hr', 'symbol', 'fullsize', '|', {
				name: 'addForm',
				tooltip: 'Formulário',
				icon: 'plus',
				exec: function (editor) {
					editor.selection.insertHTML('<sup>?formulario?</sup>');
				}
			}]
		}
		editor = new Jodit('#textEditor', editorConfig) // Cria inicialmete o editor sem conteúdo
		editor.value = ""
		editor.events.on('change', newValue => this.$emit('input', newValue))
	},

	watch: {
		//*Observa a página para mudar o conteúdo do editor
		selectedPage: {
			deep: true,
			handler(val) {
				// console.log(val)
				var conteudo = val.content // Busca o novo conteúdo a ser carregado

				// saveContent(site, pagina) Precisa de salvar as mudanças antes de substituir!

				editor.value = conteudo // Substitui o conteúdo do editor pelo novo conteúdo carregado
			}
		},
		paginaSelecionadaUrl: {
			deep: true,
			handler(val) {
				if(val && this.paginaSelecionadaUrl == null){
					// console.log('montando no watch')
					this.siteName = this.siteSelecionadoUrl.nome
					this.selectedSite = this.$route.query.siteSelecionado 
					this.pageIndex = this.$route.query.paginaSelecionada
					this.selectedPage = val
				}
			}
		}
	}
}
</script>

<style lang="sass">
// *Style da Resultam
.r-active
	background-color: rgba(0, 0, 0, 0.22) !important

// *Alterações de Style do Vuetify/Jodit
.jodit_workplace 
	border-right: none

.card--flex-toolbar
	margin-top: 0px !important
	
</style>
